import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { 
  ShoppingBag,
  Layout,
  ChevronDown,
  ChevronRight,
  Code,
  Key,
  Settings,
  Home,
  Gamepad2,
  Bitcoin,
  Wallet,
  TrendingUp,
  Trophy,
  Globe,
  Coins,
  Banknote,
  Dices,
  Sparkles,
  Target,
  Puzzle,
  Shield,
  Users
} from "lucide-react";

export const Sidebar = () => {
  const location = useLocation();
  const username = localStorage.getItem("username") || "Admin";
  const userRole = localStorage.getItem("role") || "user";
  
  // Collapsible sections - Templates closed by default, API open
  const [templatesOpen, setTemplatesOpen] = useState(false);
  const [apiOpen, setApiOpen] = useState(true);

  // Check if any template route is active
  const isTemplateActive = location.pathname.includes('/templates/');

  return (
    <aside className="sidebar" data-testid="sidebar">
      {/* Logo Header */}
      <div className="p-5 border-b border-slate-200">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center shadow-lg shadow-blue-500/25">
            <ShoppingBag className="w-5 h-5 text-white" />
          </div>
          <div>
            <h1 className="font-bold text-slate-800 text-lg" style={{ fontFamily: 'Manrope, sans-serif' }}>
              OZON
            </h1>
            <p className="text-xs text-slate-500">Manager</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 py-4 overflow-y-auto">
        {/* Profiles - Антидетект */}
        <NavLink
          to="/profiles"
          className={({ isActive }) =>
            `sidebar-item ${isActive ? "active" : ""}`
          }
          data-testid="nav-profiles"
        >
          <Users className="w-5 h-5" />
          <span>Профили</span>
        </NavLink>

        {/* Main - Главная */}
        <NavLink
          to="/"
          end
          className={({ isActive }) =>
            `sidebar-item ${isActive ? "active" : ""}`
          }
          data-testid="nav-dashboard"
        >
          <Home className="w-5 h-5" />
          <span>Главная</span>
        </NavLink>

        {/* Templates Section - Contains all templates including Crypto and Casino */}
        <div className="mt-2">
          <button 
            onClick={() => setTemplatesOpen(!templatesOpen)}
            className={`sidebar-item w-full justify-between ${isTemplateActive ? 'text-blue-600' : ''}`}
          >
            <div className="flex items-center gap-3">
              <Layout className="w-5 h-5" />
              <span>Шаблоны</span>
            </div>
            {templatesOpen ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
          </button>
          
          {templatesOpen && (
            <div className="ml-4 space-y-0.5">
              <NavLink
                to="/templates/betboom"
                className={({ isActive }) =>
                  `sidebar-item ${isActive ? "active" : ""}`
                }
                data-testid="nav-betboom"
              >
                <Gamepad2 className="w-5 h-5" />
                <span>Betboom</span>
              </NavLink>
              <NavLink
                to="/templates/cashinout"
                className={({ isActive }) =>
                  `sidebar-item ${isActive ? "active" : ""}`
                }
                data-testid="nav-cashinout"
              >
                <Bitcoin className="w-5 h-5" />
                <span>Cashinout.io</span>
              </NavLink>
              <NavLink
                to="/templates/coinpay"
                className={({ isActive }) =>
                  `sidebar-item ${isActive ? "active" : ""}`
                }
                data-testid="nav-coinpay"
              >
                <Coins className="w-5 h-5" />
                <span>CoinPay</span>
              </NavLink>
              <NavLink
                to="/templates/novapay"
                className={({ isActive }) =>
                  `sidebar-item ${isActive ? "active" : ""}`
                }
                data-testid="nav-novapay"
              >
                <Wallet className="w-5 h-5" />
                <span>ONESIX</span>
              </NavLink>
              <NavLink
                to="/templates/ligastavok"
                className={({ isActive }) =>
                  `sidebar-item ${isActive ? "active" : ""}`
                }
                data-testid="nav-ligastavok"
              >
                <Trophy className="w-5 h-5" />
                <span>Лига Ставок</span>
              </NavLink>
              <NavLink
                to="/templates/platipomiru"
                className={({ isActive }) =>
                  `sidebar-item ${isActive ? "active" : ""}`
                }
                data-testid="nav-platipomiru"
              >
                <Globe className="w-5 h-5" />
                <span>Плати по миру</span>
              </NavLink>
              <NavLink
                to="/templates/bybit"
                className={({ isActive }) =>
                  `sidebar-item ${isActive ? "active" : ""}`
                }
                data-testid="nav-bybit"
              >
                <TrendingUp className="w-5 h-5" />
                <span>P2P Биржа</span>
              </NavLink>
              <NavLink
                to="/templates/cryptotrade"
                className={({ isActive }) =>
                  `sidebar-item ${isActive ? "active" : ""}`
                }
                data-testid="nav-cryptotrade"
              >
                <TrendingUp className="w-5 h-5" />
                <span>CryptoTrade</span>
              </NavLink>
              <NavLink
                to="/templates/bitexchange"
                className={({ isActive }) =>
                  `sidebar-item ${isActive ? "active" : ""}`
                }
                data-testid="nav-bitexchange"
              >
                <Banknote className="w-5 h-5" />
                <span>BitExchange</span>
              </NavLink>
              <NavLink
                to="/templates/vulkanbet"
                className={({ isActive }) =>
                  `sidebar-item ${isActive ? "active" : ""}`
                }
                data-testid="nav-vulkanbet"
              >
                <Dices className="w-5 h-5" />
                <span>VulkanBet</span>
              </NavLink>
              <NavLink
                to="/templates/joycasino"
                className={({ isActive }) =>
                  `sidebar-item ${isActive ? "active" : ""}`
                }
                data-testid="nav-joycasino"
              >
                <Sparkles className="w-5 h-5" />
                <span>JoyCasino</span>
              </NavLink>
              <NavLink
                to="/templates/1xstavka"
                className={({ isActive }) =>
                  `sidebar-item ${isActive ? "active" : ""}`
                }
                data-testid="nav-1xstavka"
              >
                <Target className="w-5 h-5" />
                <span>1xStavka</span>
              </NavLink>
              <NavLink
                to="/templates/1win"
                className={({ isActive }) =>
                  `sidebar-item ${isActive ? "active" : ""}`
                }
                data-testid="nav-1win"
              >
                <Gamepad2 className="w-5 h-5" />
                <span>1Win</span>
              </NavLink>
              <NavLink
                to="/templates/tg-cashinout"
                className={({ isActive }) =>
                  `sidebar-item ${isActive ? "active" : ""}`
                }
                data-testid="nav-tg-onesix"
              >
                <Puzzle className="w-5 h-5" />
                <span>TG CointPay</span>
              </NavLink>
            </div>
          )}
        </div>

        {/* API Section - OPEN by default */}
        <div className="mt-2">
          <button 
            onClick={() => setApiOpen(!apiOpen)}
            className="sidebar-item w-full justify-between"
          >
            <div className="flex items-center gap-3">
              <Code className="w-5 h-5" />
              <span>API</span>
            </div>
            {apiOpen ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
          </button>
          
          {apiOpen && (
            <div className="ml-4">
              <NavLink
                to="/admin/integrations"
                className={({ isActive }) =>
                  `sidebar-item ${isActive ? "active" : ""}`
                }
                data-testid="nav-integrations"
              >
                <Key className="w-5 h-5" />
                <span>Интеграции</span>
              </NavLink>
              <NavLink
                to="/admin/personal-data"
                className={({ isActive }) =>
                  `sidebar-item ${isActive ? "active" : ""}`
                }
                data-testid="nav-personal-data"
              >
                <Settings className="w-5 h-5" />
                <span>Данные</span>
              </NavLink>
              <NavLink
                to="/admin/proxy"
                className={({ isActive }) =>
                  `sidebar-item ${isActive ? "active" : ""}`
                }
                data-testid="nav-proxy"
              >
                <Shield className="w-5 h-5" />
                <span>Прокси</span>
              </NavLink>
              <NavLink
                to="/admin/extension"
                className={({ isActive }) =>
                  `sidebar-item ${isActive ? "active" : ""}`
                }
                data-testid="nav-extension"
              >
                <Puzzle className="w-5 h-5" />
                <span>Расширение</span>
              </NavLink>
            </div>
          )}
        </div>
      </nav>

      {/* User Footer - simplified without logout */}
      <div className="p-4 border-t border-slate-200">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 bg-blue-100 rounded-full flex items-center justify-center">
            <span className="text-blue-700 font-semibold text-sm">
              {username.charAt(0).toUpperCase()}
            </span>
          </div>
          <div>
            <p className="text-sm font-medium text-slate-700">{username}</p>
            <p className="text-xs text-slate-400">
              {userRole === "admin" ? "Администратор" : 
               userRole === "supplier" ? "Поставщик" : 
               userRole === "unblocker" ? "Разблокировщик" : "Пользователь"}
            </p>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
